<template>
    <div class="login-form">
        <reset-pwd></reset-pwd>
        <div class="role-group">
            <div class="landlord-btn" :class="{active: loginType == 'LANDLORD'}" @click="loginType = 'LANDLORD'">
                個人房東
            </div>
            <div class="bussiness-btn"  :class="{active: loginType == 'BUSSINESS'}" @click="loginType = 'BUSSINESS'">
                企業會員
            </div>
        </div>
        <div class="landlord-wrap" v-if="loginType == 'LANDLORD'">
            <label for="phone" class="button-font input-label">
                手機號碼
                <span v-show="error.landlord.phoneErr" class="error-with-title">{{error.landlord.phoneErr}}</span>
            </label>
            <div class="input-group select-list phone" :class="{error: error.landlord.phoneErr}">
                <div class="input-group-prepend" @click="clickEvent">
                    <span data-id="886" class="input-group-text" > 
                        <img class="country-img" src="@/assets/img/flag/TW.png" alt="">
                        +886
                        <img class="dropdown-img" src="@/assets/img/icon/arrow_down_black.svg" alt="">
                    </span>
                    <ul v-if="dropDownShow">
                        <li>
                            <img class="country-img" src="@/assets/img/flag/TW.png" alt="">
                            +886
                        </li>
                    </ul>
                </div>
                <input class="phone-num" required name="phone" placeholder="請輸入手機號碼" type="text" v-bind:class="{ error: error.landlord.phoneErr, confirm: landlord.phone }" v-model="landlord.phone">
                <img class="cancel-img" v-show="landlord.phone" @click="clearAccount" src="@/assets/img/icon/input_clear_all.svg" alt="">
            </div>
            <div class="verify-code">
                <label for="verifyCode" class="button-font input-label" style="width: 176px;">
                    驗證碼
                    <span v-show="error.landlord.verifyCodeErr" class="error-with-title">{{error.landlord.verifyCodeErr}}</span>
                </label>
                <div class="group">
                    <input class="default-input" required name="verifyCode" placeholder="請輸入手機驗證碼" type="text" v-bind:class="{confirm: landlord.verifyCode, error: error.landlord.verifyCodeErr}" v-model="landlord.verifyCode">
                    <div v-if="timer==0" class="count-down-btn" @click="landlordRegister(), timer = 60, countDown(), $analytics.logEvent('登入頁_送出取得驗證碼', { screen_name: '登入頁_送出取得驗證碼'})" >獲取驗證碼</div>
                    <div v-else class="count-down-btn">簡訊已發送 {{timer}}</div>
                </div>
            </div>
            <div class="default-button" @click="landlordLogin(), $analytics.logEvent('登入頁_送出登入', { screen_name: '登入頁_送出登入'})">立即註冊 / 登入</div>
            <span class="private">登入及註冊即同意 <router-link :to="{ name: 'privateAndPolicy'}">會員隱私條款</router-link></span>
        </div>
        <div class="bussiness-wrap" v-if="loginType == 'BUSSINESS'">
            <!-- <div class="company-id">
                <label for="companyId" class="button-font input-label">
                    企業統編
                    <span v-show="error.bussiness.companyIdErr" class="error-with-title">{{error.bussiness.companyIdErr}}</span>
                </label>
                <div class="input-error-group">
                    <input :class="{error: error.bussiness.companyIdErr}" type="text" v-model="bussiness.companyId" placeholder="請輸入企業統編">
                </div>
            </div> -->
            <div class="account">
                <label for="account" class="button-font input-label">
                    電子郵件帳號
                    <span v-show="error.bussiness.emailErr" class="error-with-title">{{error.bussiness.emailErr}}</span>
                </label>
                <div class="input-error-group">
                    <input :class="{error: error.bussiness.emailErr}" type="text" v-model="bussiness.email" placeholder="請輸入電子郵件帳號">
                </div>
            </div>
            <div class="password">
                <label for="password" class="button-font input-label">
                    密碼
                    <span v-show="error.bussiness.passwordErr" class="error-with-title">{{error.bussiness.passwordErr}}</span>
                </label>
                <div class="input-error-group">
                    <input ref="password" :class="{error: error.bussiness.passwordErr}" type="password" v-model="bussiness.password" placeholder="請輸入密碼">
                    <div v-if="bussiness.pwdShow" @click="togglePassword()" class="show-hide-pwd">
                        <span v-if="bussiness.pwdVisible">
                            隱藏
                        </span>
                        <span v-else>
                            顯示
                        </span>
                    </div>
                </div>
            </div>
            <div class="forgot-password" @click="forgotPwd()">
                忘記密碼？
            </div>
            <div class="default-button" @click="bussinessLogin()">登入</div>
        </div>
        <div class="bussiness-not-yet" v-if="loginType == 'BUSSINESS'">
            還不是企業會員嗎？
            <div class="register-now">
            <router-link  :to="{ name: 'bizRegister'}">
                立即註冊
            </router-link>
            </div>
        </div>
        <!-- <div class="default-button" @click="login(), $analytics.logEvent('個人房東登入', { screen_name: '個人房東登入'})">立即註冊 / 登入</div>
        <span class="private">登入及註冊即同意 <router-link :to="{ name: 'privateAndPolicy'}">會員隱私條款</router-link></span> -->
    </div>
</template>
<script>
import mobileRedirect from '@/components/widge/modal/mobileRedirect.vue';
import resetPwd from '@/components/bussiness/widges/modals/resetPwd.vue';

import { apiUserRegister } from "@/apis/api.js"; 
import constant from '@/constant'
import { mapGetters } from 'vuex'

export default {
    name: 'Login',
    data () {
        return {
            loginType: 'LANDLORD',
            landlord: {
                nationalityCode: '886',
                phone: null,
                verifyCode: null,
            },
            bussiness: {
                // companyId: null,
                email: null,
                password: null,
                pwdVisible: false,
                pwdShow: false
                    
            },
            error: {
                landlord: {
                    phoneErr: null,
                    verifyCodeErr: null,
                },
                bussiness: {
                    companyIdErr: null,
                    emailErr: null,
                    verifyCodeErr: null,
                }
            },
            dropDownShow: 0,
            timer: 0,
            cx:[1,2,1,2,1,2,4,1]
        }
    },
    watch: {
        'landlord.phone': function (val) {
            let phoneReg = /^09[0-9]{8}$/;
            if( val.length > 0 ){
                if( this.landlord.nationalityCode == '886'){
                    let phone = this.phoneFormatTw(val)
                   if(!phoneReg.test(phone)) {
                        this.error.landlord.phoneErr = '格式錯誤';
                    }else{
                        this.error.landlord.phoneErr = '';
                    }
                }
            }else{
                this.error.landlord.phoneErr = '';
            }
        },
        'landlord.verifyCode': function (val) {
            if(val.length > 0){
            }else{
            }
        },
        // 'bussiness.companyId': function (val) {
        //     //公司統一編號
        //     console.log(val)
        //     if( val ){
        //         this.chknum(val)
        //     }else{
        //         this.error.bussiness.companyIdErr = null;
        //     }
        // },
        'bussiness.email': function (val) {
            let isMail = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
            
            if( val.length > 0 ){
                if (!isMail.test(val)) {
                    this.error.bussiness.emailErr = '電子郵件格式錯誤';
                }else {
                    this.error.bussiness.emailErr = null;
                }
            }else{
                this.error.bussiness.emailErr = null;
            }
        },
        'bussiness.password': function (val) {
            if(val){
                this.bussiness.pwdShow = true
            }else{
                this.bussiness.pwdShow = false
            }
        },
        $route: {
            handler: function (val) {
                if(val.query && val.query.loginType){
                    this.loginType = val.query.loginType
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted () {
        // this.$analytics.logEvent('統計分流＿房東', { screen_name: '統計分流＿房東'})
        // this.$analyticsBiz.logEvent('統計分流＿企業', { screen_name: '統計分流＿企業'})
        let _this = this;
        let el = _this.$el;
        document.addEventListener('click', function (e) {
            if( el.contains(e.target) != true){
                _this.dropUp();
            }
        })
        
    },
    methods: {
        landlordRegister: function () {
            let account = this.phoneFormatTw(this.landlord.phone)
            let nationality_code = this.landlord.nationalityCode

            let data = {
                account,
                nationality_code
            }
            this.$store.dispatch('landlordRegister',data).catch(err => {
                let alarm = {
                    status: true,
                    title: '系統發生未預期錯誤，請再試一次',
                    description: null,
                    type: 'error'
                }
                this.$store.dispatch('setAlarmStatus', alarm)
            })
        },
        landlordLogin: function () {
            if(this.mobileRedirect()){
                let account = this.phoneFormatTw(this.landlord.phone)
                let verification_code = this.landlord.verifyCode
                let nationality_code = this.landlord.nationalityCode
                let data = {account, verification_code, nationality_code}
                this.$store.dispatch('landlordLogin',data)
                .then(() => window.location = "/landlord/housestatus/home")
                .catch(err => {
                    console.log(err)
                    let alarm = {
                        status: true,
                        title: '系統發生未預期錯誤，請再試一次',
                        description: null,
                        type: 'error'
                    }
                    this.$store.dispatch('setAlarmStatus', alarm)
                })
            }
        },
        bussinessLogin: function () {
            if(this.mobileRedirect()){
                // let companyId = this.bussiness.companyId
                let email = this.bussiness.email
                let password = this.bussiness.password
                let data = {email, password}
                this.$store.dispatch('bizLogin',data)
                .then((res) => {
                    console.log(res)
                    // window.location = "/bussiness/housestatus/home"
                    // console.log(res.data.result);
                    if(this.isBizVerified == 'NOT_AUDITS'){
                        window.location = '/enterprise/bizVerified'
                        // this.$router.push({ name: 'bizVerified'})
                    }else{
                        window.location = '/enterprise/personalHome/myHome/'
                        // this.$router.push({ name: 'bizHomeDefault'})
                    }
                })
                .catch(err => {
                    if( err == 'accountErr' ){
                        this.error.bussiness.emailErr = '帳號或密碼錯誤'
                    }else if( err == 'verifyErr' ){
                        this.error.bussiness.emailErr = '尚未通過驗證'
                    }else{
                        let alarm = {
                            status: true,
                            title: '系統發生未預期錯誤，請再試一次',
                            description: null,
                            type: 'error'
                        }
                        this.$store.dispatch('setAlarmStatus', alarm)
                    }
                })
            }
        },
        chknum: function (val) {
            let NO = val;
            let SUM = 0;
            if (NO.length != 8) {
                this.error.bussiness.companyIdErr = '公司統一編號格式錯誤'
                return;
            }
            let cnum = NO.split("");
            for (let i=0; i<=7; i++) {
                if (NO.charCodeAt() < 48 || NO.charCodeAt() > 57) {
                this.error.bussiness.companyIdErr = '公司統一編號格式錯誤'
                return;
                }
                SUM += this.cc(cnum[i] * this.cx[i]);
            }
            if (SUM % 10 == 0) {
                this.error.bussiness.companyIdErr = null
            }
            else if (cnum[6] == 7 && (SUM + 1) % 10 == 0){
                this.error.bussiness.companyIdErr = null
            }else {
                this.error.bussiness.companyIdErr = '公司統一編號格式錯誤'
            }
        },
        cc: function (n){
            if (n > 9) {
                let s = n + "";
                let n1 = s.substring(0,1) * 1;
                let n2 = s.substring(1,2) * 1;
                n = n1 + n2;
            }
            return n;
        },
        forgotPwd: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'resetPwd'})
        },
        mobileRedirect: function () {
            let _self =this

            if(_self.system == 'pc'){
                return true
            }else{
                document.location = constant.fetuzbookLandlordSchema+'://';
                var time = (new Date()).getTime();
                setTimeout(function(){
                    setTimeout(function(){ // <-- start new thread after activation
                        var now = (new Date()).getTime();
                        if((now - time)<400) {
                            if(confirm('你未安裝飛豬管家，將引導AppStore')){
                                window.open(_self.appUrl)
                            }
                        }
                    }, 10); // <-- start new thread after activation
                }, 300);
            }
        },
        togglePassword: function () {
            let password = this.$refs.password;
            if (password.type === "password") {
                this.bussiness.pwdVisible = true
                password.type = "text";
            } else {
                this.bussiness.pwdVisible = false
                password.type = "password";
            }
        },
        phoneFormatTw: function (phone) {
            if(phone.substr(0, 1) == '9' && phone.length == 9){
                return phone = '0' + phone;
            }else{
                return phone;
            }
        },
        clearAccount: function () {
            this.landlord.phone = null
            this.error.landlord.phoneErr = null
        },
        dropDown: function () {
            this.dropDownShow = 1;
        },
        dropUp: function () {
            this.dropDownShow = 0;
        },
        clickEvent: function () {
            let tag = event.target.tagName;
            // console.log(tag)
            if( tag == 'LI' ){
                this.dropUp();
            }else if( tag == 'DIV' || tag == 'SPAN' || tag == 'IMG'){
                this.dropDown()
            }
        },
        countDown: function () {
            var _self = this
            if (this.timer != 0){
                this.timer--;
                setTimeout(function() {
                    _self.countDown()
                },
                1000)
            }
        },
        mobileRedirect: function () {
            let _self =this

            if(_self.system == 'pc'){
                return true
            }else{
                this.$store.dispatch('setModalStatus', {state: true, type: 'mobileRedirect'})
                // document.location = constant.fetuzbookTenantSchema+'://';
                // var time = (new Date()).getTime();
                // setTimeout(function(){
                //     setTimeout(function(){ // <-- start new thread after activation
                //         var now = (new Date()).getTime();
                //         if((now - time)<400) {
                //             if(confirm('你未安裝飛豬找房，將引導AppStore')){
                //                 window.open(_self.appUrl)
                //             }
                //         }
                //     }, 10); // <-- start new thread after activation
                // }, 300);
            }
        },
    },
    components: {
        mobileRedirect
    },
    computed: {
        ...mapGetters({
            system: 'GET_DEVICE_SYSTEM',
            appUrl: 'GET_APP_URL',
            isBizVerified: 'GET_BIZ_COMPANY_IS_VERIFIED',
        })
    },
    components: {
        resetPwd
    }
}
</script>
<style lang="scss" scoped>
    .login-form{
        width: 368px;
        background-color: #ffffff;
        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.12);
        border-radius: 8px;
        .role-group{
            display: flex;
            align-items: center;
            width: 308px;
            height: 44px;
            border-radius: 4px;
            background-color: #f3f3f3;
            margin: 30px;
            >div{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 154px;
                height: 44px;
                font-size: 16px;
                font-weight: 500;
                cursor: pointer;
                &.active{
                    color: #ffffff;
                    border-radius: 4px;
                    background-color: #ff9275;
                }
            }
        }
        // label{
        //     display: block;
        //     margin-bottom: 8px;
        // }
        span.error{
            bottom: -27px;
        }
        .landlord-wrap{
            margin: 30px;
            .phone{
                position: relative;
                width: 100%;
                margin-bottom: 24px;
                .country-img{
                    position: relative;
                    margin-right: 4px;
                }
                input{
                    width: 195px;
                    height: 30px;
                }
                .cancel-img{
                    position: absolute;
                    right: 10px;
                    cursor: pointer;
                }
            }
            .verify-code{
                margin-bottom: 30px;
                .group{
                    position: relative;
                    display: flex;
                    align-items: center;
                    input{
                        width: 144px;
                        margin-right: 12px;
                        // height: 16px;
                    }
                    input:hover{
                        border: solid 1px #CACFCD;
                    }
                    input:focus-within{
                        border: solid 1px #676362;
                    }
                    .border-button-black{
                        width: 118px;
                        height: 18px;
                        line-height: 19px;
                    }
                    .count-down-btn{
                        cursor: pointer;
                        width: 118px;
                        height: 44px;
                        border-radius: 4px;
                        background-color: #fff9f1;
                        color: #eb7859;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: 500;
                    }
                }
            }
        }
        .bussiness-wrap{
            margin: 30px 30px 24px 30px;
            .company-id,
            .account,
            .password{
                position: relative;
                width: 100%;
                margin-bottom: 24px;
                input{
                    width: 276px;
                }
            }
            .password{
                .show-hide-pwd{
                    position: absolute;
                    font-size: 12px;
                    top: 16px;
                    right: 16px;
                    cursor: pointer;
                }
            }
            .forgot-password{
                display: flex;
                justify-content: flex-end;
                margin-bottom: 12px;
                color: #676362;
                cursor: pointer;
            }
            
        }
        .bussiness-not-yet{
            display: flex;
            align-items: center;
            justify-content: center;
            border-top: 1px solid #f3f3f3;
            padding: 12px 0 15px 0;
            .register-now{
                margin-left: 4px;
                a{
                    color: #ff9275;
                }
            }
        }
        .default-button{
            height: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 24px;
            
        }
        .private{
            display: block;
            text-align: center;
            margin-top: 16px;
            margin-bottom: 6px;
            font-size: 12px;
            font-weight: 300;
            color: #676362;
            margin-bottom: 34px;
            a{
                text-decoration: underline;
            }
        }
    }
    @media screen and (max-width: 500px) {
        .login-form{
            width: 90%;
            padding-top: 1px;
            .role-group{
                width: 81%;
                margin: 30px;
                >div{
                    width: 50%;
                }
            }
            .landlord-wrap{
                .phone{
                    .country-img {
                        margin-right: 6px;
                    }
                    input{
                        font-size: 12px;
                        padding: 6px 6px 6px 10px;
                        width: 83%;
                    }
                    .input-group-prepend{
                        span{
                            font-size: 12px;
                        }
                        span:after{
                            right: 4px;
                        }
                        input{
                            font-size: 12px;
                        }
                    }
                }
                .verify-code{
                    .group{
                        input{
                            width: 43%;
                            font-size: 12px;
                        }
                        .border-button-black,
                        .count-down-btn{
                            font-size: 12px;
                            width: 45%;
                        }
                    }
                }
            }
            .bussiness-wrap{
                .account,
                .password{
                    input{
                        width: 87%;
                    }
                }
            }
            .private{
                padding-bottom: 30px;
            }
            // .account{
            //     input{
            //             width: 83%;
            //             padding: 6px 6px 6px 10px;
            //     }
            //     .input-group-prepend{
            //         span{
            //             font-size: 12px;
            //         }
            //         span:after{
            //             right: 4px;
            //         }
            //         input{
            //             font-size: 12px;
            //         }
            //     }
            // }
            // .password{
            //     .group{
            //         input{
            //             width: 43%;
            //             font-size: 12px;
            //             // padding: 13px 12px;
            //         }
            //         .border-button-black,
            //         .count-down-btn{
            //             font-size: 12px;
            //             width: 45%;
            //         }
            //     }
            // }
        }
    }
    // @media screen and (max-width: 260px) {
    //     .login-form{
    //         width: 67.4%;
    //         padding: 30px 33px;
    //         .account{
    //             input{
    //                 width: 88%;
    //             }
    //         }
    //         .password{
    //             .group{
    //                 input{
    //                     width: 49%;
    //                 }
    //                 .border-button-black,
    //                 .count-down-btn{
    //                     width: 45%;
    //                 }
    //             }
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/login/LoginComp.vue